/**
 * A constant that defines the threshold value used to determine the boundary count
 * for quick editing operations. The Quick Edit would be chaotic for large numbers of boundaries.
 *
 * @constant {number} QUICK_EDIT_BOUNDARY_COUNT_THRESHOLD
 */
export const QUICK_EDIT_BOUNDARY_COUNT_THRESHOLD = 30;
